// @flow

import React, { Component } from 'react';
// types
import { type CommissionDue } from '.';
import { type Currency, type Currencies } from '../../../utilities/types';
import { Desktop, Default, Device } from '../../../components/Responsive';
import { ModelListTd } from '../../../components/ModelListStyles';
import { DefaultIcon } from '../../../components/Icon';
import { formatCurrency } from '../../../utilities/numberFormatting';
import { history } from '../../../utilities/history';
import DefaultModelRowTr from '../../../modules/CrudTable/components/DefaultModelRowTr';
type Props = {
  data: CommissionDue,
  currency: Currency,
  currencies: Currencies,
  index: number
};
export default class TableRow extends Component<Props> {
  handleTableDetail = (currency: Currency) => {
    history.push({
      pathname: `/commission-payouts/due/${currency.iso4217}`,
      state: { prevPath: '/commission-payouts/due' }
    });
  };

  render() {
    const currency = this.props.currencies[this.props.data.currency];
    const currencyName =
      currency.currency_type === 'fiat' ? currency.iso4217 : currency.name;
    return (
      <DefaultModelRowTr
        key={this.props.index}
        onClick={() => this.handleTableDetail(currency)}
        hoverStylesMobile
        hoverStyles
      >
        <Desktop>
          <ModelListTd>
            <DefaultIcon
              name={currency.iso4217.toLowerCase()}
              color={currency.color}
            />
            {currencyName}
          </ModelListTd>
        </Desktop>
        <Device>
          <ModelListTd>
            {formatCurrency(this.props.data.transaction_amount, currency)}
          </ModelListTd>
        </Device>
        <Desktop>
          <ModelListTd right>
            {formatCurrency(this.props.data.transaction_amount, currency)}
          </ModelListTd>
        </Desktop>
        <Default>
          <ModelListTd right>
            {formatCurrency(this.props.data.transaction_fee, currency)}
          </ModelListTd>
        </Default>
        <ModelListTd right>
          {formatCurrency(this.props.data.revenue_share, currency)}
        </ModelListTd>
      </DefaultModelRowTr>
    );
  }
}
